import { render } from "./BranchSignatoryAddByOneCModel.vue?vue&type=template&id=4e8072fe"
import script from "./BranchSignatoryAddByOneCModel.vue?vue&type=script&lang=js"
export * from "./BranchSignatoryAddByOneCModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__